import { motion } from 'motion/react';
import { Wrench } from 'lucide-react';
import { Button } from './ui/button';
import { AuthBackground } from './auth/AuthBackground';

export function MaintenanceScreen() {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen relative flex flex-col overflow-hidden">
      <AuthBackground />

      <div
        className="relative z-10 flex-1 flex flex-col items-center justify-center px-6"
        style={{ paddingTop: 'env(safe-area-inset-top, 0px)' }}
      >
        {/* Logo */}
        <motion.div
          className="relative mb-8"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, type: 'spring' }}
        >
          <motion.div
            className="absolute inset-0 rounded-full bg-[#8bc43e]"
            animate={{
              scale: [1, 1.6, 1],
              opacity: [0.25, 0, 0.25],
            }}
            transition={{ duration: 2.5, repeat: Infinity, ease: 'easeOut' }}
          />
          <img
            src="./eveebuddy-logo.png"
            alt="EVee Buddy"
            className="w-24 h-24 relative z-10 drop-shadow-lg"
          />
        </motion.div>

        {/* Brand */}
        <motion.h2
          className="text-2xl font-bold text-foreground mb-1"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          EVee Buddy
        </motion.h2>
        <motion.p
          className="text-xs text-muted-foreground mb-8"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          for a worry free travel!
        </motion.p>

        {/* Maintenance card */}
        <motion.div
          className="w-full max-w-sm bg-background rounded-2xl shadow-xl border border-border/30 p-6"
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3, type: 'spring', damping: 25, stiffness: 200 }}
        >
          <div className="flex justify-center mb-4">
            <motion.div
              className="w-14 h-14 rounded-2xl bg-amber-500/10 flex items-center justify-center"
              animate={{ rotate: [0, -10, 10, -10, 0] }}
              transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut', repeatDelay: 1 }}
            >
              <Wrench className="w-7 h-7 text-amber-500" />
            </motion.div>
          </div>

          <h1 className="text-lg font-semibold text-foreground text-center mb-1">
            Under Maintenance
          </h1>
          <p className="text-sm text-muted-foreground text-center mb-5 leading-relaxed">
            We're currently performing scheduled maintenance to improve your experience. Please check back shortly.
          </p>

          <Button
            onClick={handleRetry}
            className="w-full h-12 bg-gradient-to-r from-[#8bc43e] to-[#6fa02e] hover:from-[#7ab32e] hover:to-[#5f8a26] text-white rounded-xl font-semibold shadow-lg shadow-[#8bc43e]/25 border-0"
          >
            Try Again
          </Button>
        </motion.div>
      </div>
    </div>
  );
}
